import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { ActivatedRoute, Router } from '@angular/router';
import { AgendaService } from 'src/app/services/agenda.service';
import { CategoryMasterService } from 'src/app/services/category-master.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css']
})
export class AgendaComponent implements OnInit {

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  // @Input() meetingTypeId;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};


  dtTrigger: Subject<any> = new Subject();
  dtOptions2: DataTables.Settings = {};


  showAdvFilter: boolean;
  filterLable: string;
  categoryMasterForm: FormGroup;
  agendaData: any[];
  meetingTypes: any[]
  categories: any[];
  agendaNumberSearchParm: any;
  agendaTypeSearchParm: any;
  meetingDisplay: boolean;
  categoryDisplay: boolean;
  Library: boolean;
  NonLibrary: boolean;
  categorySearch: any = null;
  meetingTypeSearch: any = null;
  meetingsSearch: any = null;
  meetingsSearchDateFrom: NgbDateStruct;
  meetingsSearchDateTo: any;
  minDateForSearchFrom: NgbDateStruct;
  minDateForSearchTo: NgbDateStruct;
  todayDateforSearchMeeting: NgbDateStruct;
  meetingDateOnSelectedType: any[];
  G_deletingID: any;
  g_searchAgendaObject: any = {
    AgendaTitle: "",
    MeetingTypeID: "",
    meetingID: "",
    CategoryID: "",
    libaryType: ""
  };
  allAvailableData: any[];
  multiSelectedAgendaData = [];
  isAllSelected: boolean = false;
  availableList: any[];
  searchedData: any[] = [];
  isSearchDivVisible = false;
  AssignMeetingType: any = null;
  AssingMeeting: any = null;
  checkAllAgenda: boolean = false;
  searcheFilteredDataAgenda: any[];
  hasEditPermission: any;
  response: boolean;
  deleteGlobal: boolean = false;
  localStorageCompanyId:any;
  isLoading: boolean = false;

  constructor(private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private categoryMasterService: CategoryMasterService,
    private agendaService: AgendaService,
    private router: Router,
    private route: ActivatedRoute) {
    this.response = false;

  }


  ngOnInit() {
    this.hasEditPermission = this.commonFunction.validateURL('Agenda', 'edit');
    this.environmentSettings = environment;

    this.commonFunction.validateURL('Agenda', '');
    //to change state from saved to default of datatable.
    // this.commonFunction.removeDataTableSaveStateKey("agendaTable");

    this.meetingDisplay = false;

    this.categoryDisplay = false;

    this.getAgendaList();

    // this.getCategoryList();

    this.getMeetingTypeList();

    $('.datatabletool').hide();

    this.dtOptions = {
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [1, 'asc'],

      // order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [1, 6], className: 'select-checkbox' }],
      // select: {  style:    'os', selector: 'td:first-child'  },
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      drawCallback: function(settings) {
        // Apply darker blue theme immediately after DataTables draws
        $('table.dataTable thead th').css({
          'background-color': '#f8f9fa',
          'color': '#1e458b',
          'border-bottom': 'none',
          'border-top': 'none'
        });
        $('table.dataTable thead th').css('box-shadow', '0 2px 0 0 #1e458b');
        $('table.dataTable tbody tr:first-child td').css('border-top', 'none');
      },
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Agenda List',
          title: 'Agenda List',
          extend: 'excel',
          exportOptions: {
            columns: [2, 3, 4, 5,7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    $('#agendaTable').on('draw.dt', function () {
      $('.datatabletool').show();
      // Apply darker blue theme immediately after DataTables draws
      $('table.dataTable thead th').css({
        'background-color': '#f8f9fa',
        'color': '#1e458b',
        'border-bottom': 'none',
        'border-top': 'none'
      });
      $('table.dataTable thead th').css('box-shadow', '0 2px 0 0 #1e458b');
      $('table.dataTable tbody tr:first-child td').css('border-top', 'none');
      // Remove any border from Group Name column (6th column)
      $('table.dataTable thead th:nth-child(6)').css({
        'border-bottom': 'none',
        'border-bottom-width': '0'
      });
      $('table.dataTable tbody td:nth-child(6)').css({
        'border-top': 'none',
        'border-top-width': '0'
      });
    });


    this.showAdvFilter = false;
    this.filterLable = "Advance Filter";
    this.categoryMasterForm = new FormGroup({
      CategoryName: new FormControl('', [Validators.required, Validators.maxLength(100), Validators.pattern("^[a-zA-Z0-9][a-zA-Z0-9 _@./$!#%&,()+-]*$")
      ]),
      IsGlobal: new FormControl('', [Validators.required]),
      MeetingType: new FormControl('', [Validators.required])
    });

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.todayDateforSearchMeeting = { year: year, month: month, day: day };



    let searchflag = localStorage.getItem('searchagneda');

    var searchAgendaObjectnew;
    if (searchflag == 'true') {
      searchAgendaObjectnew = JSON.parse(localStorage.getItem('agendainputdata'));

      if (searchAgendaObjectnew.AgendaTitle) {
        this.agendaNumberSearchParm = searchAgendaObjectnew.AgendaTitle;
      }
      if (searchAgendaObjectnew.MeetingTypeID) {
        this.meetingTypeSearch = searchAgendaObjectnew.MeetingTypeID;
      }
      if (searchAgendaObjectnew.meetingID) {
        this.meetingsSearch = searchAgendaObjectnew.meetingID;
      }
      if (searchAgendaObjectnew.libaryType == 'Library') {
        this.Library = true;
        if (searchAgendaObjectnew.CategoryID) {
          this.categorySearch = searchAgendaObjectnew.CategoryID
        }
      }
      if (searchAgendaObjectnew.libaryType == 'Non-Library') {
        this.NonLibrary = true;
      }

    }
    else {
      searchAgendaObjectnew = {
        AgendaTitle: "",
        MeetingTypeID: "",
        meetingID: "",
        CategoryID: "",
        libaryType: ""
      }
    }

    var searchAgendaObject = {
      AgendaTitle: "",
      MeetingTypeID: "",
      meetingID: "",
      CategoryID: "",
      libaryType: ""
    }

    if (this.agendaNumberSearchParm) {
      searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;
    }
    if (this.meetingTypeSearch) {
      searchAgendaObject.MeetingTypeID = this.meetingTypeSearch;
    }
    if (this.meetingsSearch) {
      searchAgendaObject.meetingID = this.meetingsSearch;
    }
    if (this.Library) {
      searchAgendaObject.libaryType = "Library";
      if (this.categorySearch) {
        searchAgendaObject.CategoryID = this.categorySearch;
      }
    }
    if (this.NonLibrary) {
      searchAgendaObject.libaryType = "Non-Library";
    }


    var self = this;
    self.searchedData = [];
    var token = localStorage.getItem('token')
    this.dtOptions2 = {
      ajax: {
        url: environment.pssServerUrl + "dataTable/agendaWithSearching/",
        type: 'post',
        data: searchAgendaObjectnew,
        headers: { "x-access-token": token },
        cache: true
      },
      columns: [
        {
          title: "<div class='md-checkbox'><input id='selectcheckboxall' select-agenda='all' class='md-checkbox md-checkbox-all' type='checkbox' /><label for='selectcheckboxall'>&nbsp;</label></div>",
          render: function (data: any, type: any, full: any) {
            return "<div class='md-checkbox'> <input id='selectcheckbox_" + full._id + "' name='checkagenda' value=" + full._id + " select-agenda=" + full._id + " class='md-checkbox md-checkbox-individual' type='checkbox' /> <label for='selectcheckbox_" + full._id + "'>&nbsp;</label></div>";
          }
        },
        {
          title: 'Group Number',
          render: function (data: any, type: any, full: any) {
            return full.groupNumber
          }
        },
        {
          title: 'Group Name',
          render: function (data: any, type: any, full: any) {
            return full.groupName
          }
        }, {
          title: 'Agenda Number',
          render: function (data: any, type: any, full: any) {
            return full.AgendaNumber
          }
        },
        {
          title: 'Meeting Type',
          render: function (data: any, type: any, full: any) {

            return full.MeetingType
          }
        }, {
          title: 'Agenda Title',
          render: function (data: any, type: any, full: any) {

            return full.AgendaTitle
          }
        }, {
          title: 'Category',
          render: function (data: any, type: any, full: any) {
            if (full.CategoryName) {
              return full.CategoryName
            } else {
              return 'N/A';
            }
          }
        }, {
          title: 'Action',
          render: function (data: any, type: any, full: any) {
            if (self.commonFunction.validateModulePermitions('Agenda', '/agenda/edit?goveva=true&email=')) {
              return '<div class="input-group"><button [appHasPermission]="{Url: /agenda/edit?goveva=true&email=, method:put, menu: Agenda}" type="button"  update-agenda=' + full._id + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-agenda=' + full._id + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: /agenda/edit?goveva=true&email=, method:put, menu: Agenda}" type="button" delete-agenda=' + full._id + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-agenda=' + full._id + '></span></button></div>';
            } else {
              return '';
            }
          }
        }],
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [1, 'asc'],

      // order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [0, 5], className: 'select-checkbox' }],
      // select: {  style:    'os', selector: 'td:first-child'  },
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      'rowCallback': function (row, data, dataIndex) {

        // self.searchedData.push(data);
        // console.log('----Row Data',data);
      }
    };


    var self = this;

    // setTimeout(function () {
    //   let table1 = $("#agendaTable").DataTable();
    //   // var searchedDataForSelectAll=[];
    //   table1.on('search.dt', function () {
    //     self.searcheFilteredDataAgenda = [];
    //     var tableData = $("#agendaTable").DataTable().column(0, { search: 'applied' }).data();
    //     // console.log(tableData.length);
    //     for (var i = 0; i < tableData.length; i++) {
    //       self.searcheFilteredDataAgenda.push(tableData[i])
    //     }


    //     var allSearchedSelected = false;
    //     if (_.size(self.searcheFilteredDataAgenda)) {

    //       for (var i = 0; i < self.agendaData.length; i++) {
    //         for (var j = 0; j < self.searcheFilteredDataAgenda.length; j++) {
    //           if (self.searcheFilteredDataAgenda[j] == self.agendaData[i].ID) {
    //             if (self.agendaData[i].SelectedTasks) {
    //             } else {
    //               allSearchedSelected = false;
    //             }
    //           }
    //         }
    //       }
    //     }
    //     if (allSearchedSelected) {
    //       self.checkAllAgenda = true;
    //     } else {
    //       self.checkAllAgenda = false;
    //     }


    //   });


    // }, 3000)

  }




  ngAfterViewInit(): void {





    // this.renderer.listenGlobal('document', 'click', (event) => {
    //   if (event.target.hasAttribute("update-agenda")) {
    //     console.log(event.target.getAttribute("update-agenda"));
    //     this.loadAgendaByIdToEdit(event.target.getAttribute("update-agenda"))
    //   }
    //   if (event.target.hasAttribute("delete-agenda")) {
    //     this.G_deletingID = event.target.getAttribute("delete-agenda");
    //     console.log(event.target.getAttribute("delete-agenda"));
    //     this.showDeleteConfirmationPopUp(event.target.getAttribute("delete-agenda"))
    //   }
    //   if (event.target.hasAttribute("select-agenda")) {
    //     if (event.target.getAttribute("select-agenda") == 'all') {


    //       if (event.target.checked) {
    //         this.isAllSelectedCheckbox(true,true)
    //       }
    //       else {
    //         this.isAllSelectedCheckbox(false,false)
    //       }

    //     } else {
    //     }
    //     console.log(this.multiSelectedAgendaData);
    //   }

    // }); 
  }
  /*
   * On Load To Get AgendaList On Table
   */
  getAgendaList() {
    this.isLoading = true;
    this.agendaData = [];
    this.agendaData = new Array<any>();
    $("#agendaTable").DataTable().destroy();

    // var self = this;

    let searchflag = localStorage.getItem('searchagneda');

    var searchAgendaObjectnew;
    if (searchflag == 'true') {
      searchAgendaObjectnew = JSON.parse(localStorage.getItem('agendainputdata'));

      if (searchAgendaObjectnew.AgendaTitle) {
        this.agendaNumberSearchParm = searchAgendaObjectnew.AgendaTitle;
      }
      if (searchAgendaObjectnew.MeetingTypeID) {
        this.meetingTypeSearch = searchAgendaObjectnew.MeetingTypeID;
      }
      if (searchAgendaObjectnew.meetingID) {
        this.meetingsSearch = searchAgendaObjectnew.meetingID;
      }
      if (searchAgendaObjectnew.libaryType == 'Library') {
        this.Library = true;
        if (searchAgendaObjectnew.CategoryID) {
          this.categorySearch = searchAgendaObjectnew.CategoryID
        }
      }
      if (searchAgendaObjectnew.libaryType == 'Non-Library') {
        this.NonLibrary = true;
      }

    }
    else {
      searchAgendaObjectnew = {
        AgendaTitle: "",
        MeetingTypeID: "",
        meetingID: "",
        CategoryID: "",
        libaryType: ""
      }
    }

    this.agendaService.getAgendaListForDataTable(searchAgendaObjectnew)
      .subscribe(agenda => {
        var self = this;
        //  console.log(agenda);
        if (agenda.status == 0) {
          this.availableList = agenda.data
          this.agendaData = agenda.data;
          this.localStorageCompanyId=JSON.parse(localStorage.getItem('companyDetails')).companyID;
          // this.agendaData.forEach(element => {
          //   element.IsSelected = false;
          // })
          for (let i = 0; i < this.agendaData.length; i++) {
            self.agendaData[i].IsSelected = false;
            if (self.agendaData[i].PSSMasterMeetingTypeID) {
              let foundObject = _.find(self.meetingTypes, function (e) {
                if (e.PSSMasterMeetingTypeID) {
                  return e.PSSMasterMeetingTypeID == self.agendaData[i].PSSMasterMeetingTypeID;
                }
              });
              if (foundObject == undefined) {
                self.agendaData.splice(i, 1);
              }
            }
          }

          this.dtTrigger.next();
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      });
  }

  /*  
   * On Load To Get Category To Bind On Dropdown On Yes Click Category
   */
  getCategoryList() {
    this.categories = [];
    this.categoryMasterService.getCategoryList()
      .subscribe(categoryList => {
        if (categoryList.status == 0) {
          this.categories = this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');
        }
      });
  }


  /*  
   * On Load To Get Metting To Bind On Dropdown On Yes click of Metting
   */
  getMeetingTypeList() {
    this.meetingTypes = [];
    this.categoryMasterService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');;
        }
      })
  }


  /*  
   * On search button click To Bind data with datatable (Advance Search).
   */
  getPSSMasterMeetingTypeID(meetingTypeSearch) {
    var isExists = _.filter(this.meetingTypes, function (element) {
      if (element._id == meetingTypeSearch) {
        return element.PSSMasterMeetingTypeID
      }
    })
    return isExists;
  }

  doAdvSearchAction() {
    this.agendaData = [];
    this.response = true;
    var searchAgendaObject = {
      AgendaTitle: "",
      MeetingTypeID: "",
      meetingID: "",
      CategoryID: "",
      libaryType: "",
      PSSMasterMeetingTypeID: ""
    }

    localStorage.setItem('searchagneda', 'true');

    let searchParmJson = []
    if (this.agendaNumberSearchParm) {
      searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;

    }
    if (this.meetingTypeSearch) {
      searchAgendaObject.MeetingTypeID = this.meetingTypeSearch;
      var pSSMasterMeetingTypeID = this.getPSSMasterMeetingTypeID(this.meetingTypeSearch);
      if (pSSMasterMeetingTypeID.length > 0) {
        searchAgendaObject['PSSMasterMeetingTypeID'] = pSSMasterMeetingTypeID[0].PSSMasterMeetingTypeID;
      } else {
        delete searchAgendaObject['PSSMasterMeetingTypeID'];
      }
    }
    if (this.meetingsSearch) {
      searchAgendaObject.meetingID = this.meetingsSearch;

    }
    if (this.Library) {
      searchAgendaObject.libaryType = "Library";
      if (this.categorySearch) {
        searchAgendaObject.CategoryID = this.categorySearch;

      }
    }
    if (this.NonLibrary) {
      searchAgendaObject.libaryType = "Non-Library";


    }

    //-----------------------------------------------------------------------------  

    var self = this;
    this.g_searchAgendaObject = searchAgendaObject;

    // console.log(this.g_searchAgendaObject);

    localStorage.setItem('agendainputdata', JSON.stringify(searchAgendaObject));
    self.searchedData = [];
    $("#agendaTable").DataTable().destroy();
    this.isLoading = true;
    this.agendaService.getAgendaListForDataTable(searchAgendaObject)
      .subscribe(agenda => {
        if (agenda.status == 0) {

          this.availableList = agenda.data
          this.agendaData = agenda.data;
 
          for (let i = 0; i < this.agendaData.length; i++) {
            self.agendaData[i].IsSelected = false;
            if (self.agendaData[i].PSSMasterMeetingTypeID) {
              let foundObject = _.find(self.meetingTypes, function (e) {
                if (e.PSSMasterMeetingTypeID) {
                  return e.PSSMasterMeetingTypeID == self.agendaData[i].PSSMasterMeetingTypeID;
                }
              });
              if (foundObject == undefined) {
                self.agendaData.splice(i, 1);
              }
            }
          }

          this.dtTrigger.next();
        }
        this.response = false;
        this.isLoading = false;
      }, error => {
        this.response = false;
        this.isLoading = false;
      });

  }


  getMeetingFromType() {
    // console.log(meetingTypeId);
    if (this.AssignMeetingType) {
      this.AssingMeeting = null;
      this.meetingDateOnSelectedType = [];
      this.agendaService.getMeetingOnTypeSelect(this.AssignMeetingType).subscribe(data => {
        // console.log('data',data.meetingData)
        if (data.meetingData.length > 0) {
          if (data.status == 0) {
            var meetingData = data.meetingData;
            this.meetingDateOnSelectedType = [];


            meetingData.forEach(element => {
              var todayDate = new Date();
              var meetingDate = new Date(element.meetingList.MeetingDate);

              if (meetingDate >= todayDate) {
                this.meetingDateOnSelectedType.push(element);
                //console.log('yy--->>>',element.meetingList.MeetingDate);
              }

            });

            meetingData.forEach(element => {
              element.meetingList.MeetingDate = new Date(element.meetingList.MeetingDate);
            })
            // meetingData=_.sortBy(meetingData, 'MeetingDate');

            this.meetingDateOnSelectedType = _.sortBy(meetingData, function (value) {
              // console.log(value, new Date(value.meetingList.MeetingDate));
              return new Date(value.meetingList.MeetingDagetCategoryByMeetingTypete);
            });
          }
        } else {
          this.meetingDateOnSelectedType = []
        }
      });
      if (this.meetingTypeSearch) {
        this.getCategoryListOnBehalfOfMeeting(this.meetingTypeSearch);
      }

    }

  }



  getCategoryListOnBehalfOfMeeting(meetingTypeId) {
    this.categories = [];
    this.categoryMasterService.getCategoryListByMeetingTypeID(meetingTypeId)
      .subscribe(categoryList => {
        if (categoryList.status == 0) {
          this.categories = this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');
        }
      });
  }

  getCategoryListFromMeetingFromAdvSearch() {
    this.categories = [];
    this.categoryMasterService.getCategoryListByMeetingTypeID(this.meetingTypeSearch)
      .subscribe(categoryList => {
        if (categoryList.status == 0) {
          this.categories = this.commonFunction.sortByKey(categoryList.categoryList, 'CategoryName');
        }
      });
  }
  /*  
   * On clear button click To clear search option data with datatable refresh with all data.
   */
  clearAdvSearchResult() {
    this.agendaData = [];
    this.response = true;
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    // });
    // $('#table2').DataTable().ajax.reload();
    // this.getAgendaList();
    this.categories = [];
    this.agendaNumberSearchParm = "";
    // this.agendaTypeSearchParm = "";
    this.meetingDisplay = false;
    this.categoryDisplay = false;
    this.Library = null;
    this.NonLibrary = null;
    this.categorySearch = null;
    this.meetingsSearch = null;
    this.meetingTypeSearch = null;
    this.meetingsSearchDateFrom = null;
    this.meetingsSearchDateTo = null;
    $(".filter-option").text("Select from the following...");
    var searchAgendaObject = {
      AgendaTitle: "",
      MeetingTypeID: "",
      meetingID: "",
      CategoryID: "",
      libaryType: ""
    }

    localStorage.setItem('searchagneda', 'false');
    localStorage.setItem('agendainputdata', null);

    if (this.agendaNumberSearchParm) {
      searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;
      // this.g_searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;
    }
    if (this.meetingTypeSearch) {
      searchAgendaObject.MeetingTypeID = this.meetingTypeSearch;
      // this.g_searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;
    }
    if (this.meetingsSearch) {
      searchAgendaObject.meetingID = this.meetingsSearch;
      // this.g_searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;
    }
    if (this.Library) {
      searchAgendaObject.libaryType = "Library";
      if (this.categorySearch) {
        searchAgendaObject.CategoryID = this.categorySearch;
        // this.g_searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;
      }
    }
    if (this.NonLibrary) {
      searchAgendaObject.libaryType = "Non-Library";

      // if (this.meetingsSearchDateFrom && this.meetingsSearchDateTo) {
      //     searchAgendaObject.meetingDateRange.from =this.commonFunction.setDate(this.meetingsSearchDateFrom).toString() ;    //mm-dd-yy formate
      //     // this.g_searchAgendaObject.AgendaTitle = this.agendaNumberSearchParm;
      //     searchAgendaObject.meetingDateRange.to = this.commonFunction.setDate(this.meetingsSearchDateTo).toString();    //mm-dd-yy formate
      //     // this.g_searchAgendaObject.meetingDateRange=   searchAgendaObject.meetingDateRange;
      //   }
    }

    //-----------------------------------------------------------------------------  

    var self = this;
    this.g_searchAgendaObject = searchAgendaObject;

    $("#agendaTable").DataTable().destroy();
    this.isLoading = true;
    this.agendaService.getAgendaListForDataTable(this.g_searchAgendaObject)
      .subscribe(agenda => {
        if (agenda.status == 0) {
          // this.availableList = agenda.data
          // this.agendaData = agenda.data;
          // this.agendaData.forEach(element => {
          //   element.IsSelected = false;
          // })
          // console.log(this.agendaData);
          this.response = false;
          // this.dtTrigger.next();
          this.availableList = agenda.data
          this.agendaData = agenda.data;
          // this.agendaData.forEach(element => {
          //   element.IsSelected = false;
          // })
          for (let i = 0; i < this.agendaData.length; i++) {
            self.agendaData[i].IsSelected = false;
            if (self.agendaData[i].PSSMasterMeetingTypeID) {
              let foundObject = _.find(self.meetingTypes, function (e) {
                if (e.PSSMasterMeetingTypeID) {
                  return e.PSSMasterMeetingTypeID == self.agendaData[i].PSSMasterMeetingTypeID;
                }
              });
              if (foundObject == undefined) {
                self.agendaData.splice(i, 1);
              }
            }
          }

          this.dtTrigger.next();
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      });

  }

  /*  
   * On select of meeting date from in search box.
   */
  meetingDateSearchMeeting() {
    var dateObj = new Date();
    this.todayDateforSearchMeeting = { year: dateObj.getUTCFullYear(), month: dateObj.getUTCMonth() + 1, day: dateObj.getUTCDate() };
    this.minDateForSearchTo = this.meetingsSearchDateFrom;
    // console.log(this.MinDocumentDateDate);
  }



  // On click of radio button to choose option from Library / Non-Library / NONE. 
  cheackOne(type) {
    if (type == 'Library') {
      this.Library = true;
      this.NonLibrary = false;
      this.meetingDisplay = false;
      this.categoryDisplay = true;
    } else if (type == 'Non-Library') {
      this.Library = false;
      this.NonLibrary = true;
      this.meetingDisplay = true;
      this.categoryDisplay = false;
    } else {
      this.Library = false;
      this.NonLibrary = false;
      this.meetingDisplay = false;
      this.categoryDisplay = false;
    }
  }


  loadAgendaByIdToEdit(agendaId) {
    // localStorage.setItem("agendaId", agendaId);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['agenda', 'edit',agendaId]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/agenda/edit', agendaId]);
  }



  // downloadDoc(_id) {
  //   this.agendaService.downloadDOCS(_id).subscribe(data => {
  //     var blob = new Blob([data]);
  //     var url = window.URL.createObjectURL(blob);
  //     // console.log(data.url),
  //     window.open(data.url);
  //   }),//console.log(data),
  //     error => console.log("Error downloading the file."),
  //     () => console.info("OK");
  // }

  addCategory() {
    if (this.categoryMasterForm.status == "VALID") {
      // debugger
      var checkGlobal = true;

      if (this.categoryMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      var newCategory = {
        IsGlobal: checkGlobal,
        CategoryName: this.categoryMasterForm.controls.CategoryName.value.trim(),
        MeetingTypeID: this.categoryMasterForm.controls.MeetingType.value
        //CompanyID:"5a3778b4323b0a2a5839474b"
      }
      this.categoryMasterService.addCategory(newCategory)
        .subscribe(category => {
          // console.log(category.status);
          if (category.status == 0) {
            $('#categoryDialog').modal('toggle');
            this.alert.success("Category created successfully.")

            // $('#alertTitle').text("Success!");
            // $('#alertTitle').css("color", "black");
            // $('#alertMessage').text("Category created successfully.");
            // $('#alertMessage').css("color", "black");
            // $('#messagePopUp').modal('toggle');
            //   this.messagePopUpTimeoutToogle();
          } else {
            $('#categoryDialog').modal('toggle');
            // $('#alertTitle').css('color', '#f00');
            // $('#alertTitle').text("Failure!");
            // $('#alertMessage').text(category.message);
            // $('#alertMessage').css('color', '#f00');
            // $('#messagePopUp').modal('toggle');
            this.alert.error(category.message);
            // this.messagePopUpTimeoutToogle();
          }

          this.categoryMasterForm.reset();

        });
    }
    else {
      console.log('Invalid form submit.')
      return false;
    }
  }


  showAddPopUp() {
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Category');
    $('#btnsaveCategory').show();
    $('#btnupdateCategory').hide();
    this.categoryMasterForm.controls.CategoryName.setValue('');
    this.categoryMasterForm.controls.IsGlobal.setValue('Company');
    // this.error = { isError: false, errorMessage: '' }
  }


  /*  
  *On click To Show alert and Set _id to delete
  */
  showDeleteConfirmationPopUp(deletingID, isGlobal) {
    this.G_deletingID = deletingID;
    this.deleteGlobal = isGlobal;
    $('#confirmation').modal('toggle');
  }

  deleteAgenda() {
    // this.G_deletingID
    this.agendaService.deleteAgenda(this.G_deletingID).subscribe((data:any) => {
      if (data.status == 0) {
        $('#confirmation').modal('toggle');
        this.alert.success(data.message);

        // $('#alertTitle').text("Success!");
        // $('#alertMessage').text(data.message);
        // $('#messagePopUp').modal('toggle');
        // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //   dtInstance.destroy();
        // });
        // this.agendaData = new Array<any>();
        // this.getAgendaList();
        // $('#table2').DataTable().ajax.reload();
        this.clearAdvSearchResult()

      }
      else {
        $('#confirmation').modal('toggle');
        this.alert.error(data.message);
        $('#table2').DataTable().ajax.reload();
        // $('#alertTitle').text("Failure!");
        // $('#alertMessage').text(data.message);
        // $('#messagePopUp').modal('toggle');
      }

    });
  }

  redirectToAddAgendaPage() {
    localStorage.removeItem('queryParams');
    localStorage.removeItem('fromMeeting');
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['agenda', 'add']  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/agenda/add']);
  }


  isAllSelectedCheckbox(Titlechecked, elementsChecked) {




    let searchflag = localStorage.getItem('searchagneda');
    var self = this;
    var searchAgendaObjectnew;
    if (searchflag == 'true') {
      searchAgendaObjectnew = JSON.parse(localStorage.getItem('agendainputdata'));

      if (searchAgendaObjectnew.AgendaTitle) {
        this.agendaNumberSearchParm = searchAgendaObjectnew.AgendaTitle;
      }
      if (searchAgendaObjectnew.MeetingTypeID) {
        this.meetingTypeSearch = searchAgendaObjectnew.MeetingTypeID;
      }
      if (searchAgendaObjectnew.meetingID) {
        this.meetingsSearch = searchAgendaObjectnew.meetingID;
      }
      if (searchAgendaObjectnew.libaryType == 'Library') {
        this.Library = true;
        if (searchAgendaObjectnew.CategoryID) {
          this.categorySearch = searchAgendaObjectnew.CategoryID
        }
      }
      if (searchAgendaObjectnew.libaryType == 'Non-Library') {
        this.NonLibrary = true;
      }

    }
    else {
      searchAgendaObjectnew = {
        AgendaTitle: "",
        MeetingTypeID: "",
        meetingID: "",
        CategoryID: "",
        libaryType: ""
      }
    }
    self.searchedData = [];
    var agendaTable = $('#table2').DataTable({
      ajax: {
        url: environment.pssServerUrl + "dataTable/agendaWithSearching/",
        type: 'post',
        data: self.g_searchAgendaObject,
        cache: true
      },
      columns: [{
        title: self.getTitle(Titlechecked),
        render: function (data: any, type: any, full: any) {
          if (elementsChecked) {

            return "<div class='md-checkbox'> <input id='selectcheckbox_" + full._id + "'  name='checkagenda' checked value=" + full._id + " select-agenda=" + full._id + " class='md-checkbox md-checkbox-individual' type='checkbox' /> <label for='selectcheckbox_" + full._id + "'>&nbsp;</label></div>";
          } else {
            return "<div class='md-checkbox'> <input id='selectcheckbox_" + full._id + "'  name='checkagenda' value=" + full._id + " select-agenda=" + full._id + " class='md-checkbox md-checkbox-individual' type='checkbox' /> <label for='selectcheckbox_" + full._id + "'>&nbsp;</label></div>";
          }

        }
      }, {
        title: 'Agenda Number',
        render: function (data: any, type: any, full: any) {
          return full.AgendaNumber
        }
      },
      {
        title: 'Meeting Type',
        render: function (data: any, type: any, full: any) {

          return full.MeetingType
        }
      }, {
        title: 'Agenda Title',
        render: function (data: any, type: any, full: any) {

          return full.AgendaTitle
        }
      }, {
        title: 'Category',
        render: function (data: any, type: any, full: any) {
          if (full.CategoryName) {
            return full.CategoryName
          } else {
            return 'N/A';
          }
        }
      }, {
        title: 'Action',
        render: function (data: any, type: any, full: any) {
          if (self.commonFunction.validateModulePermitions('Agenda', '/agenda/edit?goveva=true&email=')) {
            return '<div class="input-group"><button [appHasPermission]="{Url: /agenda/edit?goveva=true&email=, method:put, menu: Agenda}" type="button"  update-agenda=' + full._id + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-agenda=' + full._id + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: /agenda/edit?goveva=true&email=, method:put, menu: Agenda}" type="button" delete-agenda=' + full._id + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-agenda=' + full._id + '></span></button></div>';
          } else {
            return '';
          }

        }
      }],
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [2, 'asc'],
      //order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [0, 5] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    });


    var SearchedFilterData = [];
    agendaTable.on('order.dt search.dt', function () {
      let nodeList = agendaTable.column(0, { search: 'applied', order: 'applied' }).nodes()[0]
      //["0"].lastChild.childNodes[1].value

      SearchedFilterData = nodeList;
      // console.log( agendaTable.column(0, {search:'applied', order:'applied'}).nodes())
    }).draw();
    // console.log(SearchedFilterData);
    $('#table2').DataTable().ajax.reload();
  }

  getTitle(checked) {

    // console.log('serch ------------->>>>>',this.searchedData);
    var table = $('#table2').DataTable();

    table.rows().every(function () {
      // var d = table.row( this ).data();
      // var d=$("#table2").DataTable().column(0, { search:'applied' } ).data();
      // var d=table.search( this.value ).draw();
      // console.log(d);
    });
    if (checked) {
      return "<div class='md-checkbox'><input id='selectcheckboxall' checked select-agenda='all' class='md-checkbox md-checkbox-all' type='checkbox' /><label for='selectcheckboxall'>&nbsp;</label></div>";
    } else {
      return "<div class='md-checkbox'><input id='selectcheckboxall' select-agenda='all' class='md-checkbox md-checkbox-all' type='checkbox' /><label for='selectcheckboxall'>&nbsp;</label></div>"
    }

  }

  agendaSelectedCount: any = 0;
  allSelecedAgendaArray: any = [];

  AddDataToMeeting() {
    var self = this;
    this.agendaSelectedCount = 0;
    $("#addToMeetingModal").modal('toggle');
    var agendaIDArray = [];
    this.agendaData.forEach(element => {
      if (element.IsSelected) {
        agendaIDArray.push(element._id);
      }
    })
    this.allSelecedAgendaArray = agendaIDArray;
    this.agendaSelectedCount = _.size(agendaIDArray);
   
    // alert(_.size(favorite) +' Item selected')
  }

  addSelectedToMeeting() {
    var data = {
      meetingId: this.AssingMeeting,
      meetingTypeId: this.AssignMeetingType,
      agendaData: this.allSelecedAgendaArray
    }

    this.agendaService.addBulkAgendaToMeetingIn(data).subscribe(data => {
      if (data.status == 0) {
        this.clearAdvSearchResult();
        this.allSelecedAgendaArray = []
        this.agendaSelectedCount = 0;
        this.AssingMeeting = null;
        this.AssignMeetingType = null;
        $("#addToMeetingModal").modal('toggle');
        this.validateButton();

        this.alert.success(data.message);
      } else {
        $("#addToMeetingModal").modal('toggle');
        this.clearAdvSearchResult();
        this.validateButton();
        this.alert.error(data.message);
      }
    })
  }

  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  selectAllAgenda(event) {
    this.agendaSelectedCount = 0;
    this.agendaData.forEach(element => {
      // console.log(this.searcheFilteredDataAgenda);
      if (this.searcheFilteredDataAgenda) {
        for (var i = 0; i < this.searcheFilteredDataAgenda.length; i++) {
          if (this.searcheFilteredDataAgenda[i] == element._id) {
            element.IsSelected = this.checkAllAgenda;
          }
        }
      }
      else {
        element.IsSelected = this.checkAllAgenda;
      }
    });
    this.validateButton()
  }

  selectSingleAgenda(event) {
    // debugger;
    // this.agendaSelectedCount=0;
    // var flagForAllSelected=true;
    // this.agendaData.forEach(element=>{
    //   if(!element.IsSelected){
    //     flagForAllSelected=false;
    //   }
    // })
    // if(flagForAllSelected){
    //   this.checkAllAgenda=true;
    // }

    // var agendaIDArray = [];
    // this.agendaData.forEach(element=>{
    //   if(element.IsSelected){
    //     agendaIDArray.push(element._id);
    //   }
    // })
    // this.agendaSelectedCount=agendaIDArray.length;
    this.validateButton();
  }

  deleteDataFromMeeting() {

    var self = this;
    $("#deleteBulkAgenda").modal('toggle');
    var agendaIDArray = [];
    this.agendaData.forEach(element => {
      if (element.IsSelected) {
        agendaIDArray.push(element._id);
      }
    })
    this.allSelecedAgendaArray = agendaIDArray;
    this.agendaSelectedCount = _.size(agendaIDArray);

  }


  deleteSelectedAgenda() {

    this.agendaService.deleteBulkAgenda(this.allSelecedAgendaArray).subscribe(data => {
      if (data.status == 0) {
        this.clearAdvSearchResult();
        this.allSelecedAgendaArray = []
        this.agendaSelectedCount = 0;
        this.AssingMeeting = null;
        this.AssignMeetingType = null;
        $("#deleteBulkAgenda").modal('toggle');
        this.validateButton();
        this.alert.success(data.message);
      } else {
        $("#deleteBulkAgenda").modal('toggle');
        this.clearAdvSearchResult();
        this.allSelecedAgendaArray = []
        this.agendaSelectedCount = 0;
        this.validateButton();
        this.alert.error(data.message);
      }
    })
  }

  validCount: boolean = false;
  validateButton() {
    var self = this;
    self.validCount = false;
    setTimeout(function () {
      self.agendaData.forEach(element => {
        if (element.IsSelected) {
          self.validCount = true;
        }
      })
    }, 300)
    // this.allSelecedAgendaArray=agendaIDArray;
  }
}

